import { faXTwitter, faFacebookF } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import useRegion from '../../hooks/useRegion'

const platforms = [
  {
    name: 'twitter',
    className: 'xtwitter',
    icon: faXTwitter,
    url: 'https://twitter.com/share?url='
  },
  {
    name: 'facebook',
    className: 'facebook-f',
    icon: faFacebookF,
    url: 'https://www.facebook.com/sharer/sharer.php?u='
  }
]

export default ({ node }) => {
  const region = useRegion()
  const url = `https://${region.name}.news12.com/${node.attribs['data-slug']}`

  return (
    <div className='social'>
      {platforms.map(p => (
        <a key={p.name} href={`${p.url}${url}`} className={p.className} target='_blank'>
          <FontAwesomeIcon icon={p.icon} />
        </a>
      ))}
    </div>
  )
}
